import {
  FYDEOS_NOTES_PRODUCT,
  getCurrentFydeOSBrandLinks,
} from '@affine/component/product-brand';
import {
  SettingHeader,
  SettingRow,
  SettingWrapper,
} from '@affine/component/setting-components';
import { Trans, useI18n } from '@affine/i18n';
import { OpenInNewIcon } from '@blocksuite/icons/rc';

import * as styles from './style.css';

const externalLink = (href: string) => (
  <a href={href} target="_blank" rel="noreferrer" className="copyright-link" />
);

export const AboutAffine = () => {
  const t = useI18n();
  const currentYear = new Date().getFullYear();
  const links = getCurrentFydeOSBrandLinks();
  const domain = new URL(links.website).hostname;
  const isFydeOSIo = domain === 'fydeos.io';

  return (
    <>
      <SettingHeader
        title={t['com.affine.aboutAFFiNE.title']()}
        data-testid="about-title"
      />
      <SettingWrapper title={t['com.affine.aboutAFFiNE.version.title']()}>
        <SettingRow
          name={FYDEOS_NOTES_PRODUCT}
          // fix me: version
          desc={'v' + '1.0.40+0.20.0'}
          className={styles.appImageRow}
        >
          <img
            src="/imgs/notes-icon.svg"
            alt={FYDEOS_NOTES_PRODUCT}
            width={56}
            height={56}
          />
        </SettingRow>
      </SettingWrapper>
      <SettingWrapper title={t['com.affine.aboutAFFiNE.legal.title']()}>
        <a
          className={styles.link}
          rel="noreferrer"
          href={links.privacy}
          target="_blank"
        >
          {t['com.affine.aboutAFFiNE.legal.privacy']()}
          <OpenInNewIcon className="icon" />
        </a>
        <a
          className={styles.link}
          rel="noreferrer"
          href={links.terms}
          target="_blank"
        >
          {t['com.affine.aboutAFFiNE.legal.tos']()}
          <OpenInNewIcon className="icon" />
        </a>
      </SettingWrapper>
      <div className={styles.footer}>
        <Trans
          i18nKey="com.affine.aboutAFFiNE.notice.offeredBy"
          components={{ a: externalLink(links.website) }}
          values={{ website: links.website }}
        />
        <br />
        <br />
        <Trans
          i18nKey={
            isFydeOSIo
              ? 'com.affine.aboutAFFiNE.notice.developedBy.io'
              : 'com.affine.aboutAFFiNE.notice.developedBy.com'
          }
          components={{ a: externalLink(links.upstreamSource) }}
        />
        <br />
        <br />
        <Trans
          i18nKey="com.affine.aboutAFFiNE.notice.server"
          components={{ a: externalLink(links.serverSource) }}
        />
        <br />
        <br />
        {isFydeOSIo
          ? t['com.affine.aboutAFFiNE.notice.copyright.io']({
              year: String(currentYear),
            })
          : t['com.affine.aboutAFFiNE.notice.copyright.com']({
              year: String(currentYear),
            })}
        {isFydeOSIo ? (
          <>
            <br />
            <br />
            {t['com.affine.aboutAFFiNE.notice.gdpr']()}
          </>
        ) : null}
      </div>
    </>
  );
};
